module.exports = __webpack_public_path__ + "img/niño84.aa9a4f06.jpg";